
import { defineComponent, computed } from 'vue';
import { useDeviceSize } from 'SharedDir/common/composables/useDeviceSize';

export default defineComponent({
  name: 'NotificationHeader',
  props: {
    countNotifications: {
      type: Number,
      required: true,
    },
  },
  emits: ['changeVisibility', 'setAllNotificationReaded'],
  setup(props, { emit }) {
    const { isMobile, isLaptop } = useDeviceSize();

    const haveUnreadNotifications = computed(() => props.countNotifications > 0);

    return {
      isMobile,
      isLaptop,
      changeVisibilityNotificationModal: () => emit('changeVisibility'),
      notificationsReaded: () => emit('setAllNotificationReaded'),
      haveUnreadNotifications,
    };
  },
});
